<template>
  <div id="checkout">
    <menu-default/>

    <main class="page payment-page">
      <section class="int-form">
        <div class="container">
          <div class="block-heading">
            <h2><i class="fa fa-credit-card"></i> {{return_title}}</h2>
          </div>
          <form style="max-width:800px">
            <div class="card-details">
              <div class="row">
                <div :class="return_css" role="alert">
                  {{ return_message }}
                </div>
              </div>
            </div>
            <div class="card-details" style="padding-top: 0">
              <div class="row">
                <div class="form-group col-sm-12">
                  <button type="button" class="btn btn-primary btn-block" @click="redirectURL({name: 'orders'})">Visualizar pedidos</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </main>
    <footer-default/>
    </div>
</template>

<script>
    import menuDefault from "./common/menu-default"
    import footerDefault from "./common/footer-default"
    import mixins from "../helpers/mixins"
    export default {
        name: "PaymentReturn",
        mixins: [mixins],
        data() {
          return {
            return_data: {}
          }
        },
        computed: {
          return_message() {
            if(this.return_data.status !== undefined){
              if(this.return_data.status === 200) return "Seu pedido foi processado com sucesso, porém para avançar com o pagamento, antes, " +
                "nós precisaremos confirmar a autenticidade da imagem enviada. Aguarde o envio do link para o pagamento por e-mail ou acompanhe na tela de pedidos. (prazo de retorno: 24hrs)";
              if(this.return_data.status === 201) return "Pagamento não pode ser processado, tente novamente ou entre em contato conosco";
              if(this.return_data.status === 404) return "Não foi encontrada nenhuma informação sobre o processamento do seu pedido";
            }
            return false
          },
          return_title() {
            if(this.return_data.status !== undefined){
              if(this.return_data.status === 200) return "Pagamento realizado com sucesso";
              if(this.return_data.status === 201) return "Pagamento não pode ser processado";
              if(this.return_data.status === 404) return "Um erro foi encontrado";
            }
            return false
          },
          return_css() {
            if(this.return_data.status !== undefined){
              if(this.return_data.status === 200) return "alert alert-success col-sm-12";
              if(this.return_data.status === 201) return "alert alert-warning col-sm-12";
              if(this.return_data.status === 404) return "alert alert-danger col-sm-12";
            }
            return false
          }
        },
        mounted() {
          if(this.$route.params.return_data !== undefined){
            this.return_data = this.$route.params.return_data
            if(this.return_data.status !== undefined)
              if(this.return_data.status === 200) this.$store.dispatch('cleanCart')
          } else {
            this.return_data = { status: 404 }
          }
        },
        components: { menuDefault, footerDefault },
    }
</script>

<style scoped>

</style>
